<!--
 ECHARTS 的 饼图
-->
<template>
  <!-- 250px -->
  <div :id="comID" :style="pieStyle"></div>
</template>

<script>
  // 按需引入
  import 'echarts/lib/component/tooltip';
  import 'echarts/lib/component/legend';
  import 'echarts/lib/component/grid';

  import * as echarts from 'echarts/lib/echarts';
  import {
    GridComponent
  } from 'echarts/components';
  echarts.use([GridComponent]);

  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  export default {
    props: {
      // ID
      comID: {
        type: String,
        default: 'myChart_bar'
      },
      // 高度
      comHeight: {
        type: Number,
        default: 400
      },
      // 数据
      comData: {
        type: Array,
        default: () => {
          return [];
        }
      },
      comBgColor:{
        type: String,
        default: '#5470c6'
      }
    },
    data() {
      return {
        // 用于计算高度
        pieStyle: '',
        items: [],
      };
    },
    created() {
      let that = this;
      that.pieStyle = 'width: 100%; height:' + (that.comHeight * 0.0625) + 'rem;';

      that.$nextTick(() => {
        that.drawLine();
      });
    },
    mounted() {
      let that = this;
      window.onresize = function() {
        // that.myChart.resize();
        that.pieStyle = 'width: 100%; height:' + (that.comHeight * 0.0625) + 'rem;';
      }
    },
    methods: {

      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById(this.comID));



        // 绘制图表
        myChart.setOption({
          grid: {
            top: '5%',
            left: '1%',
            right: '0%',
            bottom: '5%'
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: [
                  '22级(1)班',
                  '21级(5)班',
                  '21级(2)班',
                  '21级(4)班',
                  '21级(16)班',
                  '21级(1)班',
                  '21级(9)班',
                  '21级(13)班',
                  '21级(12)班',
                  '21级(10)班',
                  '21级(3)班',
                  '21级(7)班',
                  '21级(15)班',
                  '21级(6)班',
                  '21级(14)班',
                  '21级(8)班',
                  '21级(11)班',
                  '20级(9)班',
                  '20级(13)班',
                  '20级(3)班',
                  '20级(5)班',
                  '20级(11)班',
                  '20级(8)班',
                  '20级(14)班',
                  '20级(7)班',
                  '20级(15)班',
                  '20级(2)班',
                  '20级(4)班',
                  '20级(1)班',
                  '20级(10)班',
                  '20级(6)班',
                  '20级(12)班',
                  '19级(11)班',
                ],
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  interval: 0,
                  rotate: 45
                },

              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '进出人数',
                type: 'bar',
                barWidth: '60%',
                data: [10, 52, 20, 34, 39, 30, 22,12,32,17,27,33,23,17,8,22,21,25,19,20,21,23,24,25,32,21,17,11,12,13,12,11,12],
                itemStyle: {
                  color: this.comBgColor,
                },
              }
            ]
        });
      }
    },
    watch: {
      comData() {
        let that = this;
        that.legendData = [];
        that.xAxisData = [];
        that.series = [];
        that.items = that.comData;
        that.items.forEach(element => {
          that.legendData.push(element.collegeName);
          var it = {
            name: element.collegeName,
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: [],
          }
          element.leaveList.forEach(leave => {
            it.data.push(leave.number);
          })
          that.series.push(it);
        })

        that.items[0].leaveList.forEach(element => {
          that.xAxisData.push(element.name);
        })

        that.$nextTick(() => {
          that.drawLine();
        });
      }
    }
  };
</script>

<style>

</style>
